<template>
  <div class="common-page order-management">
    <div class="top-box">
      <div class="search-form-box">
        <el-row :gutter="30">
          <el-form inline>
            <el-col :span="4">
              <el-form-item label="姓名/电话:">
                <el-input
                  style="width: 100%"
                  clearable
                  v-model="searchForm.keyword"
                  autocomplete="off"
                  placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="所属公司:" prop="companyId">
                <el-select style="width: 100%" v-model="searchForm.companyId" filterable placeholder="请选择">
                  <el-option
                    v-for="item in companyList"
                    :key="item.companyId"
                    :label="item.companyName"
                    :value="item.companyId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="线路:" prop="lineId">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.lineId"
                  filterable
                  allow-create
                  default-first-option
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in lineData"
                    :key="item.lineId"
                    :label="`${item.startProvinceName}
                    -
                    ${item.endProvinceName}`"
                    :value="item.lineId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="车牌号码:">
                <el-input
                  style="width: 100%"
                  clearable
                  v-model="searchForm.carNumber"
                  autocomplete="off"
                  placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="车型:">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.vehicleMode"
                  filterable
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in getConfig('vehicle_mode')"
                    :key="item.dictLabel"
                    :label="item.dictLabel"
                    :value="item.dictLabel"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="车长:">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.vehicleLength"
                  filterable
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in getConfig('vehicle_length')"
                    :key="item.dictLabel"
                    :label="item.dictLabel + '米'"
                    :value="item.dictLabel"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="车队长:">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.vehicleLeaderId"
                  filterable
                  allow-create
                  default-first-option
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in vehicleLeaderData"
                    :key="item.userId"
                    :label="item.username"
                    :value="item.userId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="4">
              <el-form-item label="责任调度:" prop="dispatcherId">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.keywords"
                  filterable
                  allow-create
                  default-first-option
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in dispatcherData"
                    :key="item.userId"
                    :label="item.username"
                    :value="item.userId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="在跑状态:" prop="status">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.status"
                  filterable
                  allow-create
                  default-first-option
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in $dict.runStatusOptions"
                    :key="item.dictCode"
                    :label="item.dictLabel"
                    :value="item.dictCode"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="4">
              <el-form-item label="">
                <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
                <el-button type="default" round icon="el-icon-refresh" @click="handleReset()"></el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>
      <div class="search-table-box">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd()">司机入驻申请</el-button>
        <el-button type="default" @click="handleRecord()">历史申请记录</el-button>
<!--        <el-button type="primary" @click="handleDownload()" :loading="downloadLoading">导出</el-button>-->
      </div>
    </div>

    <div class="custom-table-box">
      <custom-table
        :data="tableData"
        :column="tableColumn"
        :total="tableOptions.total"
        :loading="tableOptions.loading"
        :page="tableOptions.currentPage"
        :size="tableOptions.pageSize"
        :selection="false"
        @pagination="handleSizeChange">
        <template v-slot:status="{ row }">
          <div class="operate">
            <span class="colorf32009" v-if="row.status === 0">停跑</span>
            <span class="operate-btn status-confirm" v-if="row.status === 1">在跑</span>
          </div>
        </template>
        <template v-slot:startCityName="{ row }">
          <div v-if="row.startCityName">{{ row.startCityName }}-{{ row.endCityName }}</div>
          <div v-else>漫游线路</div>
        </template>
        <template v-slot:vehicleLength="{ row }">{{ row.vehicleLength }}米</template>
        <template v-slot:operation="{ row }">
          <span class="operate-btn" @click="handleEdit(row)">编辑</span>
          <span class="operate-btn" @click="openDetail(row)">详情</span>
          <span class="operate-btn" @click="resetPassword(row)">重置密码</span>
          <span class="operate-btn" @click="handleStatus(row)" v-if="row.status === 1">停跑</span>
          <span class="operate-btn" @click="handleStatus(row)" v-if="row.status === 0">在跑</span>
        </template>
      </custom-table>
    </div>

    <!--    添加或编辑-->
    <addOrEdit ref="addOrEdit"></addOrEdit>
    <detail ref="detail"></detail>
    <historical-records ref="historicalRecords" @openDetail="openDetail"></historical-records>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import CustomDateRange from "@/components/CustomDateRange.vue";
import addOrEdit from "./addOrEdit.vue";
import historicalRecords from "./historicalRecords.vue";
import tableMixin from "@/mixin/tableMixin";
import {getPage, resetDriverPassword, setRunOrStop} from "./api";
import detail from "./detail.vue";
import CustomCascader from "@/components/CustomCascader.vue";
import {
  getSelectCompany,
  resetPassword,
} from "@/views/SystemManagement/CompanyManagement/api";
import { getBaseLine } from "@/views/ServiceConfig/CarrierRouteConfig/api";
import { getCheDuiZhang, getDispatchers } from "@/views/commonApi";
import { getConfig } from "@/utils/localDict";
import { downloadTable } from "@/views/ApprovalCenter/DriverInformationApproval/api";
export default {
  name: "OrderManagement",
  mixins: [tableMixin],
  components: {
    CustomCascader,
    detail,
    OperateBox,
    CustomTable,
    CustomDateRange,
    historicalRecords,
    addOrEdit,
  },
  data() {
    return {
      companyList: [],
      dispatcherData: [], // 调度人
      vehicleLeaderData: [], // 车队长
      lineData: [], // 车队长
      getTableMethod: getPage,
      downloadFileMethod: downloadTable,
      searchForm: {
        carNumber: "",
        // companyId: localStorage.getItem("companyId"),
        companyId: "",
        dispatcherId: "",
        gpsId: "",
        keyword: "",
        lineId: "",
        status: "",
        vehicleLeaderId: "",
        vehicleLength: "",
        vehicleMode: "",
      },
      customOptions: [],
      tableOptions: {},
      isImmediatelyGetData: true,
      tableColumn: [
        {
          label: "司机姓名",
          prop: "username",
          align: "left",
          show: true,
        },
        {
          label: "司机联系方式",
          prop: "phone",
          align: "left",
          show: true,
        },
        {
          label: "所属机构",
          prop: "companyName",
          align: "left",
          show: true,
        },
        {
          label: "车牌号码",
          prop: "carNumber",
          align: "left",
          show: true,
        },
        {
          label: "车型",
          prop: "vehicleMode",
          align: "left",
          show: true,
        },
        {
          label: "车长",
          prop: "vehicleLength",
          align: "left",
          scopeStatus: true,
          show: true,
        },
        {
          label: "线路",
          prop: "startCityName",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "车队长",
          prop: "vehicleLeaderName",
          align: "left",
          show: true,
        },
        {
          label: "责任调度",
          prop: "dispatcherName",
          align: "left",
          show: true,
        },
        {
          label: "在跑状态",
          prop: "status",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "操作",
          prop: "operation",
          fixed: "right",
          width: "240px",
          scopeStatus: true,
          show: true,
        },
      ],
    };
  },
  watch: {
    "searchForm.companyId": function (val) {
      if (val) {
        // this.getLineData(val);
        this.getCheDuiZhang(val);
      }
    },
  },
  created() {
    this.getSelectCompany();
    this.getDiaoDu();
    this.getLineData();
  },
  mounted() {},
  methods: {
    getConfig,
    handleExport() {},
    // 获取公司下线路
    getLineData(val) {
      getBaseLine(val).then((res) => {
        if (res.code === 200) {
          this.lineData = res.data;
        }
      });
    },
    // 获取调度组下的调度人员
    getDiaoDu() {
      getDispatchers().then((res) => {
        if (res.code === 200) {
          this.dispatcherData = res.data;
        }
      });
    },
    // 获取公司下车队长
    getCheDuiZhang(val) {
      getCheDuiZhang(val).then((res) => {
        if (res.code === 200) {
          this.vehicleLeaderData = res.data;
        }
      });
    },
    // 获取公司
    getSelectCompany() {
      getSelectCompany().then((res) => {
        if (res.code === 200) {
          this.companyList = res.data;
        }
      });
    },
    openDetail(row) {
      // this.$refs.detail.init("司机详情", true, row);
      this.$refs.detail.init("司机信息审批", true, row, "examine");
    },

    handleRecord() {
      this.$refs.historicalRecords.init();
    },
    handleStatus(row) {
      // setRunOrStop({
      //   status: row.status ? 0 : 1,
      //   driverId: row.driverId,
      // }).then((res) => {
      //   if (res.code === 200) {
      //     this.$message.success("设置成功");
      //     this.getTableData();
      //   }
      // });
      this.$confirm(`确定${row.status ? "停跑" : "上线"}此司机？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        setRunOrStop({
          status: row.status ? 0 : 1,
          driverId: row.driverId,
        }).then((res) => {
          if (res.code === 200) {
            this.$message.success("设置成功");
            this.getTableData();
          }
        });
      });
    },
    resetPassword(row) {
      this.$confirm(`确定重置此司机密码？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        resetDriverPassword({
          driverId: row.driverId,
        }).then((res) => {
          if (res.code === 200) {
            this.$message.success("密码重置成功");
            // this.getTableData();
          }
        });
      });
    },
    handleAdd() {
      this.$refs.addOrEdit.init();
    },
  },
};
</script>
<style lang="scss" scoped>
.order-management {
  .search-form-title {
    font-weight: 400;
    font-size: 0.16rem;
    color: #111827;
    line-height: 0.24rem;
    padding-bottom: 0.08rem;
  }

  .drop-image {
    width: 0.24rem;
    height: 0.24rem;
  }

  .owner-requirement {
    background-color: rgba(217, 236, 255, 0.5);
    color: #1269ff;
    padding: 0.05rem;
    border-radius: 0.06rem;
  }

  .mileage {
    position: relative;
    padding: 0 0.05rem 0.06rem;
  }

  .mileage::after {
    content: "→";
    position: absolute;
    left: 0;
    bottom: -0.06rem;
    text-align: center;
    width: 100%;
  }
}
</style>
